const __WEBPACK_NAMESPACE_OBJECT__ = {"apiUrl":"/api","COMMENT_FEATURE_ENABLE":true};